export const homeStayerCount = {
    SINGLE: 1,
    MULTI: 2
}